export function shouldToggleSideNavOnBackgroundClick(
  target: HTMLElement,
  overlay: boolean,
): boolean {
  if (overlay) {
    return false;
  }
  if (!target.closest(".app-side-nav")) {
    return false;
  }
  if (target.closest("a, button, input, [role='menuitem'], label")) {
    return false;
  }
  return true;
}
